import { render, staticRenderFns } from "./_modalIframe.vue?vue&type=template&id=2ae8cd0c&"
import script from "./_modalIframe.vue?vue&type=script&lang=js&"
export * from "./_modalIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports